export const GET_CAMPAIGN_CREATIONS_DETAILS_REQUEST =
  "GET_CAMPAIGN_CREATIONS_DETAILS_REQUEST";
export const GET_CAMPAIGN_CREATIONS_DETAILS_SUCCESS =
  "GET_CAMPAIGN_CREATIONS_DETAILS_SUCCESS";
export const GET_CAMPAIGN_CREATIONS_DETAILS_ERROR =
  "GET_CAMPAIGN_CREATIONS_DETAILS_ERROR";
export const GET_CAMPAIGN_CREATIONS_DETAILS_RESET =
  "GET_CAMPAIGN_CREATIONS_DETAILS_RESET";

export const ADD_DETAILS_TO_CREATE_CAMPAIGN_REQUEST =
  "ADD_DETAILS_TO_CREATE_CAMPAIGN_REQUEST";
export const ADD_DETAILS_TO_CREATE_CAMPAIGN_SUCCESS =
  "ADD_DETAILS_TO_CREATE_CAMPAIGN_SUCCESS";
export const ADD_DETAILS_TO_CREATE_CAMPAIGN_ERROR =
  "ADD_DETAILS_TO_CREATE_CAMPAIGN_ERROR";
export const ADD_DETAILS_TO_CREATE_CAMPAIGN_RESET =
  "ADD_DETAILS_TO_CREATE_CAMPAIGN_RESET";

export const GET_MY_CREATE_CAMPAIGNS_LIST_REQUEST =
  "GET_MY_CREATE_CAMPAIGNS_LIST_REQUEST";
export const GET_MY_CREATE_CAMPAIGNS_LIST_SUCCESS =
  "GET_MY_CREATE_CAMPAIGNS_LIST_SUCCESS";
export const GET_MY_CREATE_CAMPAIGNS_LIST_ERROR =
  "GET_MY_CREATE_CAMPAIGNS_LIST_ERROR";

export const GET_MY_CREATE_CAMPAIGNS_LIST_FOR_PLAN_REQUEST =
  "GET_MY_CREATE_CAMPAIGNS_LIST_FOR_PLAN_REQUEST";
export const GET_MY_CREATE_CAMPAIGNS_LIST_FOR_PLAN_SUCCESS =
  "GET_MY_CREATE_CAMPAIGNS_LIST_FOR_PLAN_SUCCESS";
export const GET_MY_CREATE_CAMPAIGNS_LIST_FOR_PLAN_ERROR =
  "GET_MY_CREATE_CAMPAIGNS_LIST_FOR_PLAN_ERROR";

export const GET_MY_CREATE_CAMPAIGNS_MANAGER_REQUESTS_LIST_REQUEST =
  "GET_MY_CREATE_CAMPAIGNS_MANAGER_REQUESTS_LIST_REQUEST";
export const GET_MY_CREATE_CAMPAIGNS_MANAGER_REQUESTS_LIST_SUCCESS =
  "GET_MY_CREATE_CAMPAIGNS_MANAGER_REQUESTS_LIST_SUCCESS";
export const GET_MY_CREATE_CAMPAIGNS_MANAGER_REQUESTS_LIST_ERROR =
  "GET_MY_CREATE_CAMPAIGNS_MANAGER_REQUESTS_LIST_ERROR";

export const GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_REQUEST =
  "GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_REQUEST";
export const GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_SUCCESS =
  "GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_SUCCESS";
export const GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_ERROR =
  "GET_MY_CREATE_CAMPAIGNS_VENDOR_REQUESTS_LIST_ERROR";

export const CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_REQUEST =
  "CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_REQUEST";
export const CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_SUCCESS =
  "CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_SUCCESS";
export const CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_ERROR =
  "CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_ERROR";
export const CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_RESET =
  "CHANGE_CAMPAIGN_STATUS_AFTER_CREATIVE_UPLOAD_RESET";

export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_REQUEST =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_REQUEST";
export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_SUCCESS =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_SUCCESS";
export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_ERROR =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_ERROR";
export const CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_RESET =
  "CHANGE_CAMPAIGN_STATUS_AFTER_VENDOR_APPROVAL_RESET";


export const CHANGE_CAMPAIGN_DURATION_REQUEST =
  "CHANGE_CAMPAIGN_DURATION_REQUEST";
export const CHANGE_CAMPAIGN_DURATION_SUCCESS =
  "CHANGE_CAMPAIGN_DURATION_SUCCESS";
export const CHANGE_CAMPAIGN_DURATION_ERROR = "CHANGE_CAMPAIGN_DURATION_ERROR";
export const CHANGE_CAMPAIGN_DURATION_RESET = "CHANGE_CAMPAIGN_DURATION_RESET";

export const CAMPAIGN_PLAN_TYPE_REGULAR = "Regular";
export const CAMPAIGN_PLAN_TYPE_TOPICAL = "Topical";
export const CAMPAIGN_PLAN_TYPE_TRIGGER = "Trigger";
export const CAMPAIGN_PLAN_TYPE_STORE = "Store";
export const CAMPAIGN_PLAN_TYPE_KNOW = "IKnowItAll";

export const CAMPAIGN_LOGS_REQUEST = "CAMPAIGN_LOGS_REQUEST";
export const CAMPAIGN_LOGS_SUCCESS = "CAMPAIGN_LOGS_SUCCESS";
export const CAMPAIGN_LOGS_FAIL = "CAMPAIGN_LOGS_FAIL";

export const GET_ALL_CAMPAIGNS_DATA_REQUEST = "GET_ALL_CAMPAIGNS_DATA_REQUEST";
export const GET_ALL_CAMPAIGNS_DATA_SUCCESS = "GET_ALL_CAMPAIGNS_DATA_SUCCESS";
export const GET_ALL_CAMPAIGNS_DATA_FAIL = "GET_ALL_CAMPAIGNS_DATA_FAIL";
export const GET_ALL_CAMPAIGNS_DATA_RESET = "GET_ALL_CAMPAIGNS_DATA_RESET";

export const GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_REQUEST =
  "GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_REQUEST";
export const GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_SUCCESS =
  "GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_SUCCESS";
export const GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_FAIL =
  "GET_CAMPAIGN_LOGS_BY_CAMPAIGN_ID_FAIL";

export const GET_CAMPAIGN_DATA_REQUEST = "GET_CAMPAIGN_DATA_REQUEST";
export const GET_CAMPAIGN_DATA_SUCCESS = "GET_CAMPAIGN_DATA_SUCCESS";
export const GET_CAMPAIGN_DATA_FAIL = "GET_CAMPAIGN_DATA_FAIL";
export const GET_CAMPAIGN_DATA_RESET = "GET_CAMPAIGN_DATA_RESET";

export const GET_CAMPAIGN_CREATION_SCREENS_DATA_REQUEST =
  "GET_CAMPAIGN_CREATION_SCREENS_DATA_REQUEST";
export const GET_CAMPAIGN_CREATION_SCREENS_DATA_SUCCESS =
  "GET_CAMPAIGN_CREATION_SCREENS_DATA_SUCCESS";
export const GET_CAMPAIGN_CREATION_SCREENS_DATA_FAIL =
  "GET_CAMPAIGN_CREATION_SCREENS_DATA_FAIL";
export const GET_CAMPAIGN_CREATION_SCREENS_DATA_RESET =
  "GET_CAMPAIGN_CREATION_SCREENS_DATA_RESET";

export const CAMPAIGN_STATUS_CHANGE_REQUEST = "CAMPAIGN_STATUS_CHANGE_REQUEST";
export const CAMPAIGN_STATUS_CHANGE_SUCCESS = "CAMPAIGN_STATUS_CHANGE_SUCCESS";
export const CAMPAIGN_STATUS_CHANGE_FAIL = "CAMPAIGN_STATUS_CHANGE_FAIL";
export const CAMPAIGN_STATUS_CHANGE_RESET = "CAMPAIGN_STATUS_CHANGE_RESET";

export const EDIT_ALL_SUB_CAMPAIGNS_REQUEST = "EDIT_ALL_SUB_CAMPAIGNS_REQUEST";
export const EDIT_ALL_SUB_CAMPAIGNS_SUCCESS = "EDIT_ALL_SUB_CAMPAIGNS_SUCCESS";
export const EDIT_ALL_SUB_CAMPAIGNS_FAIL = "EDIT_ALL_SUB_CAMPAIGNS_FAIL";
export const EDIT_ALL_SUB_CAMPAIGNS_RESET = "EDIT_ALL_SUB_CAMPAIGNS_RESET";

export const EDIT_CAMPAIGN_CREATIVE_END_DATE_REQUEST =
  "EDIT_CAMPAIGN_CREATIVE_END_DATE_REQUEST";
export const EDIT_CAMPAIGN_CREATIVE_END_DATE_SUCCESS =
  "EDIT_CAMPAIGN_CREATIVE_END_DATE_SUCCESS";
export const EDIT_CAMPAIGN_CREATIVE_END_DATE_FAIL =
  "EDIT_CAMPAIGN_CREATIVE_END_DATE_FAIL";
export const EDIT_CAMPAIGN_CREATIVE_END_DATE_RESET =
  "EDIT_CAMPAIGN_CREATIVE_END_DATE_RESET";

export const CLONE_CAMPAIGN_REQUEST = "CLONE_CAMPAIGN_REQUEST";
export const CLONE_CAMPAIGN_SUCCESS = "CLONE_CAMPAIGN_SUCCESS";
export const CLONE_CAMPAIGN_FAIL = "CLONE_CAMPAIGN_FAIL";
export const CLONE_CAMPAIGN_RESET = "EDIT_CAMPAIGN_CREATIVE_END_DATE_RESET";

export const GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_REQUEST =
  "GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_REQUEST";
export const GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_SUCCESS =
  "GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_SUCCESS";
export const GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_FAIL =
  "GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_FAIL";
export const GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_RESET =
  "GET_CAMPAIGN_REQUEST_FINAL_APPROVAL_DETAILS_RESET";

export const APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_REQUEST =
  "APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_REQUEST";
export const APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_SUCCESS =
  "APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_SUCCESS";
export const APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_FAIL =
  "APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_FAIL";
export const APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_RESET =
  "APPROVE_CAMPAIGN_FINALLY_PROOH_ADMIN_RESET";

export const DOWNLOAD_CAMPAIGN_SUMMARY_PPT_REQUEST =
  "DOWNLOAD_CAMPAIGN_SUMMARY_PPT_REQUEST";
export const DOWNLOAD_CAMPAIGN_SUMMARY_PPT_SUCCESS =
  "DOWNLOAD_CAMPAIGN_SUMMARY_PPT_SUCCESS";
export const DOWNLOAD_CAMPAIGN_SUMMARY_PPT_FAIL =
  "DOWNLOAD_CAMPAIGN_SUMMARY_PPT_FAIL";
export const DOWNLOAD_CAMPAIGN_SUMMARY_PPT_RESET =
  "DOWNLOAD_CAMPAIGN_SUMMARY_PPT_RESET";

export const CAMPAIGN_STATUS_PENDING = "Pending"; // plea not accepted
export const CAMPAIGN_STATUS_ACTIVE = "Active"; // played on screen
export const CAMPAIGN_STATUS_DELETED = "Deleted"; // deleted
export const CAMPAIGN_STATUS_PAUSE = "Pause"; // pause by screen owner
export const CAMPAIGN_STATUS_REJECTED = "Rejected"; // pause by screen owner
export const CAMPAIGN_STATUS_COMPLETED = "Completed"; // endDate >= current date
export const CAMPAIGN_STATUS_HOLD = "Hold"; //

export const EDIT_CAMPAIGN = "edit";
export const VIEW_CAMPAIGN = "view";

export const EXCEL_DATA_TARGET_STORES = "ExcelDataTargetStores";

// sov constants
export const CONTINUOUS_SOV = "continuous";
export const ORDERED_SOV = "ordered";
export const RANDOM_SOV = "random";
export const SOV_TYPE_ARRAY = [
  "Select SOV Type",
  "ordered",
  "continuous",
  "random",
];



export const CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_SENT = "PleaRequestBudgetSent"
export const CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_ACCEPTED = "PleaRequestBudgetAccepted"
export const CAMPAIGN_STATUS_PLEA_REQUEST_BUDGET_REJECTED = "PleaRequestBudgetRejected"
export const CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_SENT =
  "PleaRequestScreenApprovalSent";
export const CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_ACCEPTED =
  "PleaRequestScreenApprovalAccepted";
export const CAMPAIGN_STATUS_PLEA_REQUEST_SCREEN_APPROVAL_REJECTED =
  "PleaRequestScreenApprovalRejected";
// export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_SENT = "PleaRequestFinalApprovalSent"
// export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_ACCEPTED = "PleaRequestFinalApprovalAccepted"
// export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_REJECTED = "PleaRequestFinalApprovalRejected"

export const CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_SENT = "PleaRequestClientBudgetApprovalSent"
export const CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_ACCEPTED = "PleaRequestClientBudgetApprovalAccepted"
export const CAMPAIGN_STATUS_PLEA_REQUEST_CLIENT_BUDGET_APPROVAL_REJECTED = "PleaRequestClientBudgetApprovalRejected"

export const CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_SENT = "PleaRequestVendorBudgetApprovalSent"
export const CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_ACCEPTED = "PleaRequestVendorBudgetApprovalAccepted"
export const CAMPAIGN_STATUS_PLEA_REQUEST_VENDOR_BUDGET_APPROVAL_REJECTED = "PleaRequestVendorBudgetApprovalRejected"

export const CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_SENT = "PleaRequestCreativeApprovalSent"
export const CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_ACCEPTED = "PleaRequestCreativeApprovalAccepted"
export const CAMPAIGN_STATUS_PLEA_REQUEST_CREATIVE_APPROVAL_REJECTED = "PleaRequestCreativeApprovalRejected"

export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_SENT = "PleaRequestFinalApprovalSent"
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_ACCEPTED = "PleaRequestFinalApprovalAccepted"
export const CAMPAIGN_STATUS_PLEA_REQUEST_FINAL_APPROVAL_REJECTED = "PleaRequestFinalApprovalRejected"